/**
 * T-SHELF-01 — Shelf lander hierarchy (Shoplift JS API + theme).
 * Alannah SUB-001 · Bundle vs Video + Shopping module order.
 *
 * Assignment via Shoplift; UI applied here for performance.
 * Control-first: no DOM work until variant is confirmed.
 * Loads only on /pages/led-shelf-lighting.
 *
 * Control (Liquid): Video + Shopping (custom_content_9KBnwX) above Bundle
 * Variant: Bundle (products_bundle_xk7GGz) moved above Video + Shopping
 *
 * Shoplift IDs:
 *   Original (control): 01a0a131-4174-7803-8db9-cf718bb84d36
 *   Variant (gate on):  01a0a131-4500-7423-9306-11dc23c028b9
 *
 * Shoplift → Variant → Edit Code: paste
 * docs/cro-t-shelf-01-shoplift-variant-edit-code.js
 *
 * Preview force: ?slVariant=01a0a131-4500-7423-9306-11dc23c028b9
 */
(function () {
  'use strict';

  var HYPOTHESIS_ID = '01a0a131-4500-7423-9306-11dc23c028b9';
  var WAIT_MS = 4000;
  var POLL_MS = 50;
  var VIDEO_SECTION_KEY = 'custom_content_9KBnwX';
  var BUNDLE_SECTION_KEY = 'products_bundle_xk7GGz';

  function waitForShoplift(timeoutMs) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function tick() {
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
          resolve(window.shoplift);
          return;
        }
        if (Date.now() - start >= timeoutMs) {
          resolve(null);
          return;
        }
        setTimeout(tick, POLL_MS);
      })();
    });
  }

  function sectionByKey(key) {
    return document.querySelector('[id*="__' + key + '"]');
  }

  function forceVariantFromQuery() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var forced = params.get('slVariant');
      return forced === HYPOTHESIS_ID;
    } catch (e) {
      return false;
    }
  }

  function applyVariant() {
    var video = sectionByKey(VIDEO_SECTION_KEY);
    var bundle = sectionByKey(BUNDLE_SECTION_KEY);
    if (!video || !bundle || !video.parentNode) return false;
    if (bundle.nextElementSibling === video) {
      document.documentElement.setAttribute('data-cro-t-shelf-01', 'variant');
      return true;
    }
    video.parentNode.insertBefore(bundle, video);
    document.documentElement.setAttribute('data-cro-t-shelf-01', 'variant');
    document.documentElement.setAttribute('data-cro-hypothesis', HYPOTHESIS_ID);
    return true;
  }

  function markControl() {
    document.documentElement.setAttribute('data-cro-t-shelf-01', 'control');
  }

  async function run() {
    if (document.documentElement.dataset.croTShelf01Ran === '1') return;
    document.documentElement.dataset.croTShelf01Ran = '1';

    var path = window.location.pathname || '';
    if (path.indexOf('/pages/led-shelf-lighting') === -1) return;

    if (forceVariantFromQuery()) {
      applyVariant();
      return;
    }

    var shoplift = await waitForShoplift(WAIT_MS);
    if (!shoplift) {
      markControl();
      return;
    }

    var isVariant = false;
    try {
      isVariant = await shoplift.isHypothesisActive(HYPOTHESIS_ID);
    } catch (e) {
      markControl();
      return;
    }

    if (!isVariant) {
      markControl();
      return;
    }

    applyVariant();
  }

  window.__croTShelf01 = {
    apply: applyVariant,
    hypothesisId: HYPOTHESIS_ID,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
